<template>
  <v-container fluid>
    <page-header showBackButton></page-header>

    <v-card class="mb-8">
      <v-card-text>
        <v-form ref="basicForm" @submit.prevent>
          <!-- Basic Form -->
          <v-row class="ma-0">
            <v-col cols="12" sm="6" lg="4">
              <form-select
                label="planType"
                :fieldValue.sync="formData.type"
                :options="$planTypeOptions"
                required
                @changed="refreshSetting()"
              />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-select label="companyType" :fieldValue.sync="formData.company_type" :options="companyTypeOptions" />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-input label="nameZh" :fieldValue.sync="formData.name_zh" required />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-input label="nameEn" :fieldValue.sync="formData.name_en" />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-input label="captionZh" :fieldValue.sync="formData.subtitle_zh" />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-input label="captionEn" :fieldValue.sync="formData.subtitle_en" />
            </v-col>
            <v-col cols="12" sm="6" lg="4">
              <form-select label="status" :fieldValue.sync="formData.status" :options="$statusOptions" required />
            </v-col>

            <v-col cols="12" sm="6" lg="4">
              <form-input label="price" :fieldValue.sync="formData.price" type="number" prefix="HK$" required />
            </v-col>

            <v-col cols="12" sm="6" lg="4" v-if="formData.type === 'update_corporate_info'">
              <form-input label="displayPriceZh" :fieldValue.sync="formData.display_price_zh" required />
            </v-col>
            <v-col cols="12" sm="6" lg="4" v-if="formData.type === 'update_corporate_info'">
              <form-input label="displayPriceEn" :fieldValue.sync="formData.display_price_en" />
            </v-col>

            <v-col
              cols="12"
              sm="6"
              lg="4"
              v-if="formData.type === 'create_company_limited' || formData.type === 'create_company_unlimited'"
            >
              <form-input label="govFee" :fieldValue.sync="formData.government_charge" type="number" prefix="HK$" />
            </v-col>
          </v-row>

          <!-- 服務 -->
          <v-row
            class="ma-0"
            v-if="
              formData.type === 'create_company_limited' ||
                formData.type === 'create_company_unlimited' ||
                formData.type === 'virtual_office' ||
                formData.type === 'secretary'
            "
          >
            <v-col cols="12">
              <h4 class="section-title">{{ $t('service') }}</h4>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type === 'create_company_limited'">
              <v-checkbox
                v-model="serviceData.check_function"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.check_function')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type === 'create_company_limited'">
              <v-checkbox
                v-model="serviceData.ci"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.ci')"
              ></v-checkbox>
              <form-select
                v-if="serviceData.ci"
                label="type"
                :fieldValue.sync="formData.ci_type"
                :options="ciTypeOptions"
                required
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              lg="3"
              v-if="formData.type === 'create_company_limited' || formData.type === 'create_company_unlimited'"
            >
              <v-checkbox
                v-model="serviceData.br"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.br')"
              ></v-checkbox>
              <form-select
                v-if="serviceData.br"
                label="type"
                :fieldValue.sync="formData.br_type"
                :options="ciTypeOptions"
                required
                dense
              />
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type === 'create_company_limited'">
              <v-checkbox
                v-model="serviceData.articles"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.articles')"
              ></v-checkbox>
              <form-select
                v-if="serviceData.articles"
                label="type"
                :fieldValue.sync="formData.articles_type"
                :options="articlesTypeOptions"
                required
                dense
              />
              <form-input
                v-if="serviceData.articles && formData.articles_type === 'x'"
                :fieldValue.sync="formData.articles_value"
                type="number"
                isIntegerOnly
                suffix="book"
                required
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              lg="3"
              v-if="formData.type === 'create_company_limited' || formData.type === 'secretary'"
            >
              <v-checkbox
                v-model="serviceData.secretary"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.secretary')"
              ></v-checkbox>
            </v-col>
            <v-col
              cols="12"
              md="6"
              lg="3"
              v-if="formData.type === 'create_company_limited' || formData.type === 'secretary'"
            >
              <v-checkbox
                v-model="serviceData.annual_report"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.annual_report')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type !== 'secretary'">
              <v-checkbox
                v-model="serviceData.company_address"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.company_address')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type !== 'secretary'">
              <v-checkbox
                v-model="serviceData.directory"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.directory')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type !== 'secretary'">
              <v-checkbox
                v-model="serviceData.mail"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.mail')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type !== 'secretary'">
              <v-checkbox
                v-model="serviceData.package"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.package')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type !== 'secretary'">
              <v-checkbox
                v-model="serviceData.refer"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.refer')"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type === 'create_company_limited'">
              <v-checkbox
                v-model="serviceData.green_box"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.green_box')"
              ></v-checkbox>
              <form-select
                v-if="serviceData.green_box"
                label="type"
                :fieldValue.sync="formData.green_box_type"
                :options="greenBoxTypeOptions"
                required
                dense
              />
              <form-input
                v-if="serviceData.green_box && formData.green_box_type === 'x'"
                :fieldValue.sync="formData.green_box_value"
                type="number"
                prefix="HK$"
                required
                dense
                isIntegerOnly
              />
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type === 'create_company_limited'">
              <v-checkbox
                v-model="serviceData.scr"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.scr')"
              ></v-checkbox>
              <form-select
                v-if="serviceData.scr"
                label="type"
                :fieldValue.sync="formData.scr_type"
                :options="greenBoxTypeOptions"
                required
                dense
              />
              <form-input
                v-if="serviceData.scr && formData.scr_type === 'x'"
                :fieldValue.sync="formData.scr_value"
                type="number"
                prefix="HK$"
                required
                dense
                isIntegerOnly
              />
            </v-col>
            <v-col cols="12" md="6" lg="3" v-if="formData.type === 'create_company_unlimited'">
              <v-checkbox
                v-model="serviceData.stamp"
                class="custom-checkbox"
                :label="$t('addonServiceOptions.stamp')"
              ></v-checkbox>
            </v-col>

            <template v-if="formData.type === 'secretary'">
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.br_extend_agent"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.br_extend_agent')"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.edit_member"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.edit_member')"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.edit_scr"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.edit_scr')"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.alert_record"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.alert_record')"
                ></v-checkbox>
                <form-select
                  v-if="serviceData.alert_record"
                  label="type"
                  :fieldValue.sync="formData.alert_record_type"
                  :options="greenBoxTypeOptions"
                  required
                  dense
                />
                <form-input
                  v-if="serviceData.alert_record && formData.alert_record_type === 'x'"
                  :fieldValue.sync="formData.alert_record_value"
                  type="number"
                  prefix="HK$"
                  required
                  dense
                  isIntegerOnly
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.update_business"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.update_business')"
                ></v-checkbox>
                <form-select
                  v-if="serviceData.update_business"
                  label="type"
                  :fieldValue.sync="formData.update_business_type"
                  :options="greenBoxTypeOptions"
                  required
                  dense
                />
                <form-input
                  v-if="serviceData.update_business && formData.update_business_type === 'x'"
                  :fieldValue.sync="formData.update_business_value"
                  type="number"
                  prefix="HK$"
                  required
                  dense
                  isIntegerOnly
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.update_address"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.update_address')"
                ></v-checkbox>
                <form-select
                  v-if="serviceData.update_address"
                  label="type"
                  :fieldValue.sync="formData.update_address_type"
                  :options="greenBoxTypeOptions"
                  required
                  dense
                />
                <form-input
                  v-if="serviceData.update_address && formData.update_address_type === 'x'"
                  :fieldValue.sync="formData.update_address_value"
                  type="number"
                  prefix="HK$"
                  required
                  dense
                  isIntegerOnly
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.update_company_name"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.update_company_name')"
                ></v-checkbox>
                <form-select
                  v-if="serviceData.update_company_name"
                  label="type"
                  :fieldValue.sync="formData.update_company_name_type"
                  :options="greenBoxTypeOptions"
                  required
                  dense
                />
                <form-input
                  v-if="serviceData.update_company_name && formData.update_company_name_type === 'x'"
                  :fieldValue.sync="formData.update_company_name_value"
                  type="number"
                  prefix="HK$"
                  required
                  dense
                  isIntegerOnly
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.submit_sub_br"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.submit_sub_br')"
                ></v-checkbox>
                <form-select
                  v-if="serviceData.submit_sub_br"
                  label="type"
                  :fieldValue.sync="formData.submit_sub_br_type"
                  :options="greenBoxTypeOptions"
                  required
                  dense
                />
                <form-input
                  v-if="serviceData.submit_sub_br && formData.submit_sub_br_type === 'x'"
                  :fieldValue.sync="formData.submit_sub_br_value"
                  type="number"
                  prefix="HK$"
                  required
                  dense
                  isIntegerOnly
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.update_sub_info"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.update_sub_info')"
                ></v-checkbox>
                <form-select
                  v-if="serviceData.update_sub_info"
                  label="type"
                  :fieldValue.sync="formData.update_sub_info_type"
                  :options="greenBoxTypeOptions"
                  required
                  dense
                />
                <form-input
                  v-if="serviceData.update_sub_info && formData.update_sub_info_type === 'x'"
                  :fieldValue.sync="formData.update_sub_info_value"
                  type="number"
                  prefix="HK$"
                  required
                  dense
                  isIntegerOnly
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <v-checkbox
                  v-model="serviceData.update_director"
                  class="custom-checkbox"
                  :label="$t('addonServiceOptions.update_director')"
                ></v-checkbox>
                <form-select
                  v-if="serviceData.update_director"
                  label="type"
                  :fieldValue.sync="formData.update_director_type"
                  :options="greenBoxTypeOptions"
                  required
                  dense
                />
                <form-input
                  v-if="serviceData.update_director && formData.update_director_type === 'x'"
                  :fieldValue.sync="formData.update_director_value"
                  type="number"
                  prefix="HK$"
                  required
                  dense
                  isIntegerOnly
                />
              </v-col>
            </template>
          </v-row>
        </v-form>

        <!-- 增值服務 -->
        <v-row
          class="ma-0 mt-4"
          v-if="formData.type === 'create_company_limited' || formData.type === 'create_company_unlimited'"
        >
          <v-col cols="12">
            <div class="ma-0 d-flex align-start">
              <div style="width: 100%; max-width: 350px;">
                <form-select label="addon" :fieldValue.sync="selectedAddon" :options="addonsOptions" hideDetails />
              </div>

              <v-btn class="ml-2" :disabled="$store.getters.isLoading" color="primary" @click="addAddon()">{{
                $t('add')
              }}</v-btn>
            </div>
          </v-col>

          <v-col cols="12">
            <datatable
              :tableHeaders="addonTableHeaders"
              :tableData="formData.addons"
              disableToolbar
              disablePagination
              @delete-clicked="removeAddon($event)"
            >
              <template v-slot:[`item.type`]="{ item }">{{ item.type | formatAddonType }}</template>
              <template v-slot:[`item.company_type`]="{ item }">{{ item.company_type | formatCompanyType }}</template>
            </datatable>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div class="d-flex align-center">
      <v-btn class="mt-2" :loading="$store.getters.isLoading" color="primary" @click="save()">{{ $t('save') }}</v-btn>
    </div>

    <confirm-dialog ref="confirmDeleteDialog" />
  </v-container>
</template>

<script>
import FormInput from '@/components/form/FormInput.vue'
import FormSelect from '@/components/form/FormSelect.vue'
import Datatable from '@/components/Datatable.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  name: 'PlanDetail',
  components: {
    FormInput,
    FormSelect,
    Datatable,
    ConfirmDialog,
  },
  computed: {
    id() {
      const id = parseInt(this.$route.params.id)
      if (!isNaN(id)) {
        return id
      }

      return null
    },
  },
  data: vm => ({
    formData: {
      status: 'active',
      type: '',
      government_charge: '',
      price: '',
      name_zh: '',
      name_en: '',
      subtitle_zh: '',
      subtitle_en: '',
      company_type: '',
      ci_type: 'normal',
      br_type: 'normal',
      articles_type: 'normal',
      articles_value: '',
      green_box_type: 'normal',
      green_box_value: '',
      scr_type: 'normal',
      scr_value: '',
      alert_record_type: 'normal',
      alert_record_value: '',
      update_business_type: 'normal',
      update_business_value: '',
      update_address_type: 'normal',
      update_address_value: '',
      update_company_name_type: 'normal',
      update_company_name_value: '',
      submit_sub_br_type: 'normal',
      submit_sub_br_value: '',
      update_sub_info_type: 'normal',
      update_sub_info_value: '',
      update_director_type: 'normal',
      update_director_value: '',
      addons: [],
      display_price_zh: '',
      display_price_en: '',
    },
    serviceData: {
      check_function: false,
      ci: false,
      br: false,
      articles: false,
      secretary: false,
      annual_report: false,
      company_address: false,
      directory: false,
      mail: false,
      package: false,
      refer: false,
      green_box: false,
      scr: false,
      stamp: false,
      br_extend_agent: false,
      edit_member: false,
      edit_scr: false,
      alert_record: false,
      update_business: false,
      update_address: false,
      update_company_name: false,
      submit_sub_br: false,
      update_sub_info: false,
      update_director: false,
    },

    allAddons: [],
    addonsOptions: [],
    selectedAddon: -1,
    addonTableHeaders: [
      { value: 'type', text: vm.$t('type') },
      { value: 'company_type', text: vm.$t('companyType') },
      { value: 'name', text: vm.$t('service') },
      { value: 'price', text: vm.$t('price') },
      { value: 'actionDelete', text: '', align: 'end' },
    ],

    ciTypeOptions: [
      { value: 'normal', text: vm.$t('addonServiceTypeOptions.normal') },
      { value: 'electronic', text: vm.$t('addonServiceTypeOptions.electronic') },
    ],
    articlesTypeOptions: [
      { value: 'normal', text: vm.$t('addonServiceTypeOptions.normal') },
      { value: 'electronic', text: vm.$t('addonServiceTypeOptions.electronic') },
      { value: 'x', text: vm.$t('addonServiceTypeOptions.unitBook') },
    ],
    greenBoxTypeOptions: [
      { value: 'normal', text: vm.$t('addonServiceTypeOptions.normal') },
      { value: 'electronic', text: vm.$t('addonServiceTypeOptions.electronic') },
      { value: 'x', text: vm.$t('addonServiceTypeOptions.price') },
    ],
    companyTypeOptions: [{ value: '', text: vm.$t('na') }, ...vm.$companyTypeOptions],
  }),
  methods: {
    async getPlan() {
      try {
        const data = await this.$Fetcher.GetPlanById(this.id)
        for (let key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        for (let key in this.serviceData) {
          if (this.$validate.DataValid(data[key])) {
            if (data[key] !== 0) {
              this.serviceData[key] = true

              switch (key) {
                case 'ci':
                case 'br':
                  if (data[key] === -2) {
                    this.$set(this.formData, `${key}_type`, 'electronic')
                  }
                  break
                case 'articles':
                case 'green_box':
                case 'scr':
                case 'alert_record':
                case 'update_business':
                case 'update_address':
                case 'update_company_name':
                case 'submit_sub_br':
                case 'update_sub_info':
                case 'update_director':
                  if (data[key] === -2) {
                    this.$set(this.formData, `${key}_type`, 'electronic')
                  } else if (data[key] > 0) {
                    this.$set(this.formData, `${key}_type`, 'x')
                    this.$set(this.formData, `${key}_value`, data[key])
                  }
                  break
              }
            }
          }
        }

        this.formData.addons = data.addons.map(id => {
          const found = this.allAddons.find(el => el.id === id)
          return {
            id: id,
            type: found.type,
            company_type: found.company_type,
            name: `${found.name_zh}\n${found.name_en}`,
            price: found.price,
          }
        })

        this.getAddonOptions()
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setAlert', {
          message: 'noData',
          redirect: 'PlanList',
        })
      } finally {
        this.$store.dispatch('setInitLoading', false)
      }
    },

    refreshSetting() {
      for (let key in this.serviceData) {
        this.serviceData[key] = false
      }

      this.formData.ci_type = 'normal'
      this.formData.br_type = 'normal'
      this.formData.articles_type = 'normal'
      this.formData.articles_value = ''
      this.formData.green_box_type = 'normal'
      this.formData.green_box_value = ''
      this.formData.scr_type = 'normal'
      this.formData.scr_value = ''
      this.formData.alert_record_type = 'normal'
      this.formData.alert_record_value = ''
      this.formData.update_business_type = 'normal'
      this.formData.update_business_value = ''
      this.formData.update_address_type = 'normal'
      this.formData.update_address_value = ''
      this.formData.update_company_name_type = 'normal'
      this.formData.update_company_name_value = ''
      this.formData.submit_sub_br_type = 'normal'
      this.formData.submit_sub_br_value = ''
      this.formData.update_sub_info_type = 'normal'
      this.formData.update_sub_info_value = ''
      this.formData.update_director_type = 'normal'
      this.formData.update_director_value = ''
      this.formData.addons = []
      if (this.formData.type === 'update_corporate_info') {
        // this.formData.price = '0';
      } else {
        this.formData.display_price_zh = ''
        this.formData.display_price_en = ''
      }
      this.getAddonOptions()
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const valid = await this.$refs['basicForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', {
          message: 'required',
        })
        return
      }

      this.$store.dispatch('setLoading', true)
      let payload = {
        status: this.formData.status,
        type: this.formData.type,
        government_charge: this.formData.government_charge ? parseFloat(this.formData.government_charge) : 0,
        price: parseFloat(this.formData.price),
        original_price: parseFloat(this.formData.price),
        name_zh: this.formData.name_zh,
        name_en: this.formData.name_en,
        subtitle_zh: this.formData.subtitle_zh,
        subtitle_en: this.formData.subtitle_en,
        company_type: this.formData.company_type,
        addons: this.formData.addons.map(el => el.id),
        display_price_zh: this.formData.display_price_zh,
        display_price_en: this.formData.display_price_en,
      }

      // -2(電子版) -1(include) 0(no) >0=amount
      for (let key in this.serviceData) {
        if (this.serviceData[key]) {
          payload[key] = -1
          switch (key) {
            case 'ci':
            case 'br':
              if (this.formData[`${key}_type`] === 'electronic') {
                payload[key] = -2
              }
              break
            case 'articles':
            case 'green_box':
            case 'scr':
            case 'alert_record':
            case 'update_business':
            case 'update_address':
            case 'update_company_name':
            case 'submit_sub_br':
            case 'update_sub_info':
            case 'update_director':
              if (this.formData[`${key}_type`] === 'electronic') {
                payload[key] = -2
              } else if (this.formData[`${key}_type`] === 'x') {
                payload[key] = parseInt(this.formData[`${key}_value`])
              }
              break
          }
        } else {
          payload[key] = 0
        }
      }

      if (this.$validate.DataValid(this.id)) {
        try {
          await this.$Fetcher.UpdatePlan(this.id, payload)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            type: 'success',
            message: 'message.saveSuccess',
            refresh: true,
          })
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setAlert', {
            title: 'message.saveFail',
            message: err,
            type: 'error',
          })
        }
      } else {
        try {
          await this.$Fetcher.NewPlan(payload)
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            type: 'success',
            message: 'message.saveSuccess',
            redirect: 'PlanList',
          })
        } catch (err) {
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setAlert', {
            title: 'message.saveFail',
            message: err,
            type: 'error',
          })
        }
      }
    },

    // -------------------- 增值服務 --------------------
    async getAddons() {
      try {
        const { data } = await this.$Fetcher.GetAddons()
        this.allAddons = data
      } catch (err) {
        this.$common.error(err)
      }
    },
    getAddonOptions() {
      if (this.formData.type === 'create_company_limited') {
        this.addonsOptions = this.allAddons
          .filter(el => el.company_type === 'limited')
          .map(item => {
            return { value: item.id, text: item.name_zh }
          })
      } else if (this.formData.type === 'create_company_unlimited') {
        this.addonsOptions = this.allAddons
          .filter(el => el.company_type === 'unlimit')
          .map(item => {
            return { value: item.id, text: item.name_zh }
          })
      } else {
        this.addonsOptions = []
      }
    },
    addAddon() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

     
      const exist = this.formData.addons.find(el => el.id == this.selectedAddon)
      if (exist) {
        return
      }

      const found = this.allAddons.find(el => el.id == this.selectedAddon)
      if (found) {
        this.formData.addons.push({
          id: found.id,
          type: found.type,
          company_type: found.company_type,
          name: `${found.name_zh}\n${found.name_en}`,
          price: found.price,
        })
      }
    },
    removeAddon(id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const findPos = this.formData.addons.findIndex(el => el.id === id)
      if (findPos > -1) {
        this.formData.addons.splice(findPos, 1)
      }
    },
  },

  async mounted() {
    this.$store.dispatch('setInitLoading', true)
    await this.getAddons()
    if (this.$validate.DataValid(this.id)) {
      // edit
      this.getPlan()
    } else {
      // new
      this.$store.dispatch('setInitLoading', false)
    }
  },
}
</script>
